import MoonMark from "@/components/MoonMark";

const PHASES = ["new", "waxing", "full", "waning", "new"];

const PhaseGlyph = ({ phase, className = "w-5 h-5" }) => {
  if (phase === "full") {
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="8" fill="currentColor" />
      </svg>
    );
  }
  if (phase === "new") {
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    );
  }
  const flip = phase === "waning";
  return (
    <svg viewBox="0 0 24 24" className={`${className} ${flip ? "scale-x-[-1]" : ""}`} aria-hidden="true">
      <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.2" />
      <path d="M12 4a8 8 0 0 1 0 16Z" fill="currentColor" />
    </svg>
  );
};

export const MoonPhaseRow = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-7 text-gold/70 ${className}`} aria-hidden="true">
    {PHASES.map((p, i) => (
      <div key={i} className="flex items-center gap-7">
        <PhaseGlyph phase={p} />
        {i < PHASES.length - 1 && <span className="h-px w-10 bg-gradient-to-r from-line via-gold/30 to-line" />}
      </div>
    ))}
  </div>
);

export const Divider = ({ className = "" }) => (
  <div className={`flex items-center gap-5 ${className}`} aria-hidden="true">
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-line to-line" />
    <MoonMark className="w-5 h-5 text-gold/70" />
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-line to-line" />
  </div>
);

export const TattooBanner = ({ className = "" }) => (
  <div className={`relative w-full overflow-hidden ${className}`} aria-hidden="true">
    <img
      src="/images/tattoo_strip.jpg"
      alt=""
      className="w-full h-24 md:h-36 object-cover object-center opacity-70 mix-blend-screen"
    />
  </div>
);

export const Glyph = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 2c.8 4.9 2.3 8.9 10 10-7.7 1.1-9.2 5.1-10 10-.8-4.9-2.3-8.9-10-10 7.7-1.1 9.2-5.1 10-10Z" fill="currentColor" />
  </svg>
);
